import { render, staticRenderFns } from "./DashboardBI.vue?vue&type=template&id=0b395bbe&scoped=true"
import script from "./DashboardBI.vue?vue&type=script&lang=js"
export * from "./DashboardBI.vue?vue&type=script&lang=js"
import style0 from "./DashboardBI.vue?vue&type=style&index=0&id=0b395bbe&prod&lang=scss"
import style1 from "./DashboardBI.vue?vue&type=style&index=1&id=0b395bbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b395bbe",
  null
  
)

export default component.exports